import { useMutation } from 'react-query';
import { IUpdateInvoiceData } from '../../pages/Invoices/InvoiceOnboarding/types/types';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
    invoiceCustomData: IUpdateInvoiceData;
    customerId: string;
    customLogoExternalId: string;
    isEditMode: boolean;
}

export const useUpdateInvoiceSettingsMutation = ({
  customerId, invoiceCustomData, customLogoExternalId, isEditMode,
}: IProps) => useMutation(
  'updateInvoiceSettingsMutation',
  async () => {
    const updatedPayload = { ...invoiceCustomData };
    if (updatedPayload.brandColor) {
      updatedPayload.brandColor = updatedPayload.brandColor.replaceAll('#', '');
      updatedPayload.brandColor = `#${updatedPayload.brandColor}`;
    }
    if (invoiceCustomData.logoFileId && customLogoExternalId) {
      updatedPayload.logoFileId = customLogoExternalId;
    }
    if (isEditMode) {
      updatedPayload.finishCustomization = true;
    }
    const { data } = await httpService.post(`${BASE_URL}/api/v2/user/${customerId}/invoice/setting`, updatedPayload);
    return data;
  },
  {
    retry: 1,
  },
);
